var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('p',[_vm._v(_vm._s(_vm.year)+"年"+_vm._s(_vm.month)+"月のご利用明細は存在しません。")])])}
var staticRenderFns = []

export { render, staticRenderFns }